/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HomeHealthCertificationSigner
 */
export interface HomeHealthCertificationSigner {
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    credentials: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    npi: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    role: HomeHealthCertificationSignerRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    performer_type: HomeHealthCertificationSignerPerformerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    attestation_language: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    signed_at: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    method: HomeHealthCertificationSignerMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationSigner
     */
    citation: string;
}


/**
 * @export
 */
export const HomeHealthCertificationSignerRoleEnum = {
    PrimaryAuthor: 'primary_author',
    AttendingAttestation: 'attending_attestation',
    Cosigner: 'cosigner',
    Unknown: 'unknown'
} as const;
export type HomeHealthCertificationSignerRoleEnum = typeof HomeHealthCertificationSignerRoleEnum[keyof typeof HomeHealthCertificationSignerRoleEnum];

/**
 * @export
 */
export const HomeHealthCertificationSignerPerformerTypeEnum = {
    Physician: 'physician',
    Np: 'np',
    Cns: 'cns',
    Pa: 'pa',
    Cnm: 'cnm',
    Rn: 'rn',
    Lpn: 'lpn',
    SocialWorker: 'social_worker',
    Pt: 'pt',
    Ot: 'ot',
    Slp: 'slp',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type HomeHealthCertificationSignerPerformerTypeEnum = typeof HomeHealthCertificationSignerPerformerTypeEnum[keyof typeof HomeHealthCertificationSignerPerformerTypeEnum];

/**
 * @export
 */
export const HomeHealthCertificationSignerMethodEnum = {
    Electronic: 'electronic',
    Handwritten: 'handwritten',
    Unknown: 'unknown'
} as const;
export type HomeHealthCertificationSignerMethodEnum = typeof HomeHealthCertificationSignerMethodEnum[keyof typeof HomeHealthCertificationSignerMethodEnum];


/**
 * Check if a given object implements the HomeHealthCertificationSigner interface.
 */
export function instanceOfHomeHealthCertificationSigner(value: object): value is HomeHealthCertificationSigner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('credentials' in value) || value['credentials'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('performer_type' in value) || value['performer_type'] === undefined) return false;
    if (!('attestation_language' in value) || value['attestation_language'] === undefined) return false;
    if (!('signed_at' in value) || value['signed_at'] === undefined) return false;
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('citation' in value) || value['citation'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationSignerFromJSON(json: any): HomeHealthCertificationSigner {
    return HomeHealthCertificationSignerFromJSONTyped(json, false);
}

export function HomeHealthCertificationSignerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationSigner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'credentials': json['credentials'],
        'npi': json['npi'],
        'role': json['role'],
        'performer_type': json['performer_type'],
        'attestation_language': json['attestation_language'],
        'signed_at': json['signed_at'],
        'method': json['method'],
        'citation': json['citation'],
    };
}

export function HomeHealthCertificationSignerToJSON(json: any): HomeHealthCertificationSigner {
    return HomeHealthCertificationSignerToJSONTyped(json, false);
}

export function HomeHealthCertificationSignerToJSONTyped(value?: HomeHealthCertificationSigner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'credentials': value['credentials'],
        'npi': value['npi'],
        'role': value['role'],
        'performer_type': value['performer_type'],
        'attestation_language': value['attestation_language'],
        'signed_at': value['signed_at'],
        'method': value['method'],
        'citation': value['citation'],
    };
}

